/**
 * Erros das consultas da aba "Meus Estudos" (Flux Personalizado) que pedem um tratamento próprio.
 */

/* eslint-disable import/prefer-default-export */
import type { ResponseError } from 'services/api/base';

/** Status do envelope quando o estudo não existe (ou a rota não existe: o backend não separa). */
const NOT_FOUND_CODE = 404;

/**
 * O estudo não existe mais: 404 no `code` do envelope do backend (HTTP 200), que o baseQuery
 * normaliza em `{ status: 404, data: message }`. Exige essa forma: um HTTP 404 de gateway ou
 * proxy chega sem o envelope (o `data` normalizado fica vazio) e não conta como estudo inexistente.
 *
 * O backend responde `code: 404` também a uma rota desconhecida ("Pagina nao encontrada."), então
 * quem trata o 404 avisa o Sentry (ver `getMyStudyScenarios` em `services/api/myStudies`).
 *
 * @param error - `error` do hook ou da query do RTK Query.
 * @returns true para o 404 do envelope.
 */
export function isStudyNotFound(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const { status, data } = error as Partial<ResponseError>;
  return status === NOT_FOUND_CODE && typeof data === 'string';
}
